import React from "react";
import { HOTEL } from "@/lib/site";
import { Phone } from "lucide-react";

export default function StickyBook() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 sm:hidden bg-bone/90 backdrop-blur-xl border-t border-stone/15 px-4 py-3 flex gap-3"
      data-testid="sticky-book-bar"
    >
      <a
        href={HOTEL.phoneHref}
        data-testid="sticky-call"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-forest text-forest py-3 text-sm font-medium"
      >
        <Phone size={16} /> Call
      </a>
      <a
        href={HOTEL.booking}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-book"
        className="flex-[2] inline-flex items-center justify-center rounded-full bg-amber text-bone py-3 text-sm font-semibold"
      >
        Book Now &amp; Save
      </a>
    </div>
  );
}
